import { render, staticRenderFns } from "./AccountReportingAdvancelist.vue?vue&type=template&id=b3703214&"
import script from "./AccountReportingAdvancelist.vue?vue&type=script&lang=js&"
export * from "./AccountReportingAdvancelist.vue?vue&type=script&lang=js&"
import style0 from "./AccountReportingAdvancelist.vue?vue&type=style&index=0&id=b3703214&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer})
